//
import keyBy from 'lodash/keyBy';
import {
  FETCH_TOURS,
  FETCH_TOURS_SUCCESS,
  QUEUE_TOUR,
  DEQUEUE_TOUR,
  INCREMENT_CURRENT_STEP,
  SKIP_CURRENT_STEP,
  COMPLETE_CURRENT_TOUR,
  PRIORITIZE_TOUR
} from './types';
import { LOGIN_SUCCESS } from '../auth';
import { updateWithViewedStep, removeFromTourQueue, getFirstUnviewedStepIndex } from './util';
import { FtueAction, FtueState } from './types';

const initialState = {
  toursViewed: {},
  allTours: {},
  queuedTours: [],
  currentStep: 0,
  fetching: false,
  error: false
};

function tourReducer(state: FtueState = initialState, action: FtueAction) {
  switch (action.type) {
    case FETCH_TOURS:
      return {
        ...state,
        fetching: true,
        error: false
      };
    case LOGIN_SUCCESS: {
      const tours = action.user?.settings?.tours || [];
      const keyField =
        Array.isArray(tours) && tours.length > 0 && tours[0].tourId !== undefined
          ? 'tourId'
          : 'name';
      return {
        ...state,
        toursViewed: keyBy(tours, keyField)
      };
    }
    case FETCH_TOURS_SUCCESS:
      return {
        ...state,
        fetching: false,
        allTours: action.tours
      };
    case QUEUE_TOUR: {
      const isFirst = state.queuedTours.length === 0;
      return {
        ...state,
        currentStep: isFirst ? getFirstUnviewedStepIndex(action.name, state) : state.currentStep,
        queuedTours: [...state.queuedTours, action.name]
      };
    }
    case DEQUEUE_TOUR: {
      const updatedQueue = removeFromTourQueue(state, action.names);
      const activeChanged = updatedQueue[0] !== state.queuedTours[0];
      return {
        ...state,
        currentStep: activeChanged ? 0 : state.currentStep,
        queuedTours: updatedQueue
      };
    }
    case PRIORITIZE_TOUR: {
      const activeChanged = action.name !== state.queuedTours[0];
      return {
        ...state,
        currentStep: activeChanged
          ? getFirstUnviewedStepIndex(action.name, state)
          : state.currentStep,
        queuedTours: [action.name, ...state.queuedTours]
      };
    }
    case INCREMENT_CURRENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
        toursViewed: updateWithViewedStep(state, action.step)
      };
    case SKIP_CURRENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1
      };
    case COMPLETE_CURRENT_TOUR: {
      const queuedTours = state.queuedTours.slice(1);

      return {
        ...state,
        currentStep: 0,
        queuedTours
      };
    }

    default:
      return state;
  }
}

export default tourReducer;
